<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Date"><br>
                                <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                            </base-input>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-input label="Location">
                                <a-cascader v-model="inputLocation" :options="locationOptions" @change="onLocationChange" placeholder="All Locations" style="width: 100%" />
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input alternative="" label="Select Site">
                                <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                    <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                </a-select>
                            </base-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Group By" >
                                <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                    <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <base-input label="Sort By" >
                                <select class="form-control" size="large" v-model="inputSortBy">>
                                    <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </base-input>
                        </div>
                        <div class="col-md-2 mt-3 pt-3">
                            <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                            </button>
                        </div>
                    </div>

                    <div class="row" v-if="site_type == 'ho'">
                        <div class="col-md-4">
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate per site
                            </base-checkbox>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                {{toggleLabel}}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
            <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
            </a-drawer>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'division_id',
                groupOptions: [
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'grouper_id',
                sortOptions: [
                    {key: 'grouper_id', value: 'Division'},
                    {key: 'total_amount', value: 'Total Amount'},
                    {key: 'qty', value: 'Total Quantity'}
                ],
                birSalesReports: [],

                inputLocation: [],
                locationOptions: [],
                isSeparateSite: true,
                
                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                inputBrand: null,
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            component_x.getBrandOptions();
        },
        computed: {
            ...mapState(['currentProfile','endPoint', 'categoriesOptions']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == 'department_id'){
                    this.sortOptions[0].value = 'Department'
                } else if(e.target.value == 'section_id'){
                    this.sortOptions[0].value = 'Section'
                } else {
                    this.sortOptions[0].value = 'Division'
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            generateReport: async function () {
                this.spinning = true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'category_returns?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];

                    let header_detail = [];
                    let header_top = [
                        {content: this.sortOptions[0].value, rowSpan: 2, styles: {halign: 'center', valign: 'center'}},
                        {content: 'Returns', colSpan: 2, styles: {halign: 'center', valign: 'center'}}
                    ];

                    header_detail.push(
                        {content: 'Total Qty', styles: {halign: 'center', valign: 'center'}},
                        {content: 'Total Amount', styles: {halign: 'center', valign: 'center'}}
                    )

                    headers = [header_top, header_detail]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            let total_qty = 0
                            let total_total_amount = 0

                            let grand_qty = 0
                            let grand_total_amount = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [{content: grouper_name, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    reportLine.detail_name,
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    this.convertToCurrency(Number(reportLine.total_amount))
                                ]

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)

                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    sub_detail = ['Sub Total :',
                                        this.convertToCurrency(total_qty),
                                        this.convertToCurrency(total_total_amount)
                                    ]
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total
                                    reportData.push(Object.assign({}, ["rowLine"]))

                                    let grand_detail = ['Grand Total :',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_total_amount)
                                    ]
                                    reportData.push(Object.assign({}, grand_detail));

                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        sub_detail = ['Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_total_amount)
                                        ]

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_total_amount = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Category Returns Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(340,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(340,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 200},
                            1: {cellWidth: 65},
                            2: {cellWidth: 65}
                        }

                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: {bottom: 30},
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && data.row.raw[0] == 'Grand Total :'){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();

                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Category Returns Report" + group_text, 340, 200, i, pageCount)
                        }

                        
                    }

                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Category_Returns_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;
            },
            generateFile: async function() {
                this.spinning = true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }

                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_from": this.inputDate[0].format('YYYY-MM-DD HH:mm:ss'),
                    "date_to": this.inputDate[1].format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                    ...((this.inputLocation.length > 0) && {"location_path": this.inputLocation.toString()}),
                    "advanced_filter": this.params
                }

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'category_returns?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                let siteSpecific = get_request;
                if(get_request.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_top = [this.sortOptions[0].value];

                    header_top.push('Returns Total Qty','Returns Total Amount')

                    headers = header_top

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push([])
                            reportData.push(["Division", "Sales Total Qty", "Sales Total Amount"])
                        }

                        if(this.birSalesReports.length > 0){
                            let total_qty = 0
                            let total_total_amount = 0

                            let grand_qty = 0
                            let grand_total_amount = 0

                            let grouper = 'start'
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id

                                let detail = []
                                detail = [
                                    reportLine.detail_name,
                                    this.convertToCurrency(Number(reportLine.qty)),
                                    this.convertToCurrency(Number(reportLine.total_amount))
                                ]

                                total_qty += Number(reportLine.qty)
                                total_total_amount += Number(reportLine.total_amount)

                                grand_qty += Number(reportLine.qty)
                                grand_total_amount += Number(reportLine.total_amount)

                                reportData.push(Object.assign({}, detail))

                                let sub_detail = []
                                if(i == this.birSalesReports.length-1){
                                    sub_detail = ['Sub Total :',
                                        this.convertToCurrency(total_qty),
                                        this.convertToCurrency(total_total_amount)
                                    ]
                                    reportData.push(Object.assign({}, sub_detail))

                                    //Grand Total

                                    let grand_detail = ['Grand Total :',
                                        this.convertToCurrency(grand_qty),
                                        this.convertToCurrency(grand_total_amount)
                                    ]
                                    reportData.push(Object.assign({}, grand_detail));

                                } else {
                                    let current_grouper = ""
                                    let next_grouper = ""

                                    current_grouper = reportLine.grouper_id
                                    next_grouper = this.birSalesReports[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        sub_detail = ['Sub Total :',
                                            this.convertToCurrency(total_qty),
                                            this.convertToCurrency(total_total_amount)
                                        ]

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                        total_total_amount = 0
                                    }
                                }
                            }

                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.sortOptions[0].value
                        }

                        if(this.isSeparateSite == true){
                            reportData.push([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }
                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Category Returns Report" + group_text, "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },

            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.params = params
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            async getSubBrandData() {
                if (this.inputBrand != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_id=" +
                        this.inputBrand,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
